import { SUBSCRIPTION_NAMES } from 'src/constants/builderConstants';

export const PAGINATION_APPEARANCE_LAYOUTS = [
  {
    name: 'layout1',
    cdn: 'https://cdn.dotpe.in/longtail/themes/8603030/prjBPU6l.webp',
    subscription: [
      SUBSCRIPTION_NAMES.ESSENTIAL,
      SUBSCRIPTION_NAMES.ELITE,
      SUBSCRIPTION_NAMES.PRO,
    ],
    configs: {
      updateConfigs: [
        {
          forType: '',
          getData(activeWidgetProps) {
            return 'layout1';
          },
        },
      ],
    },
  },
  {
    name: 'layout2',
    cdn: 'https://cdn.dotpe.in/longtail/themes/8603030/Y5KDTF2u.webp',
    subscription: [
      SUBSCRIPTION_NAMES.ESSENTIAL,
      SUBSCRIPTION_NAMES.ELITE,
      SUBSCRIPTION_NAMES.PRO,
    ],
    configs: {
      updateConfigs: [
        {
          forType: '',
          getData(activeWidgetProps) {
            return 'layout2';
          },
        },
      ],
    },
  },
  {
    name: 'layout3',
    cdn: 'https://cdn.dotpe.in/longtail/themes/8603030/gS35QzFb.webp',
    subscription: [SUBSCRIPTION_NAMES.ELITE, SUBSCRIPTION_NAMES.PRO],
    configs: {
      updateConfigs: [
        {
          forType: '',
          getData(activeWidgetProps) {
            return 'layout3';
          },
        },
      ],
    },
  },
];

export const FILTER_DESIGN_LAYOUTS_DESKTOP = [
  {
    name: 'layout0',
    cdn: 'https://cdn.dotpe.in/longtail/themes/8073865/HdQUhy5R.webp',
    subscription: [
      SUBSCRIPTION_NAMES.ESSENTIAL,
      SUBSCRIPTION_NAMES.ELITE,
      SUBSCRIPTION_NAMES.PRO,
    ],
    configs: {
      updateConfigs: [
        {
          accessKey: '',
          getData(activeWidgetProps) {
            return 'layout0';
          },
        },
      ],
    },
  },
  {
    name: 'layout1',
    cdn: 'https://cdn.dotpe.in/longtail/themes/8073865/bYHIuP5G.webp',
    subscription: [
      SUBSCRIPTION_NAMES.ESSENTIAL,
      SUBSCRIPTION_NAMES.ELITE,
      SUBSCRIPTION_NAMES.PRO,
    ],
    configs: {
      updateConfigs: [
        {
          accessKey: '',
          getData(activeWidgetProps) {
            return 'layout1';
          },
        },
        {
          accessKey: ['sortAndFilter', 'desktop_configs', 'filter_options_size'],
          getData(activeWidgetProps) {
            return 'medium';
          },
        },
        {
          accessKey: ['sortAndFilter', 'filter_options_thickness'],
          getData(activeWidgetProps) {
            return 'regular';
          },
        },
        {
          accessKey: ['sortAndFilter', 'filter_options_color'],
          getData(activeWidgetProps) {
            return '#586072';
          },
        },
        {
          accessKey: ['caligraphyCollection', 'text_size_desktop'],
          getData(activeWidgetProps) {
            return 'extraLarge';
          },
        },
        {
          accessKey: ['caligraphyCategory', 'text_size_desktop'],
          getData(activeWidgetProps) {
            return 'extraLarge';
          },
        },
      ],
    },
  },
  {
    name: 'layout2',
    cdn: 'https://cdn.dotpe.in/longtail/themes/8073865/OwZXIUXl.webp',
    subscription: [
      SUBSCRIPTION_NAMES.ESSENTIAL,
      SUBSCRIPTION_NAMES.ELITE,
      SUBSCRIPTION_NAMES.PRO,
    ],
    configs: {
      updateConfigs: [
        {
          accessKey: '',
          getData(activeWidgetProps) {
            return 'layout2';
          },
        },
        {
          accessKey: ['sortAndFilter', 'desktop_configs', 'title_size'],
          getData(activeWidgetProps) {
            return 'regular';
          },
        },
           {
          accessKey: ['sortAndFilter', 'title_thickness'],
          getData(activeWidgetProps) {
            return 'regular';
          },
        },
        {
          accessKey: ['sortAndFilter', 'title_color'],
          getData(activeWidgetProps) {
            return '#111C36';
          },
        },
         {
          accessKey: ['sortAndFilter', 'desktop_configs', 'filter_options_size'],
          getData(activeWidgetProps) {
            return 'medium';
          },
        },
        {
          accessKey: ['sortAndFilter', 'filter_options_thickness'],
          getData(activeWidgetProps) {
            return 'regular';
          },
        },
        {
          accessKey: ['sortAndFilter', 'filter_options_color'],
          getData(activeWidgetProps) {
            return '#586072';
          },
        },
        {
          accessKey: ['caligraphyCollection', 'text_size_desktop'],
          getData(activeWidgetProps) {
            return 'displayLarge';
          },
        },
        {
          accessKey: ['caligraphyCategory', 'text_size_desktop'],
          getData(activeWidgetProps) {
            return 'displayLarge';
          },
        }
      ],
    },
  },
  {
    name: 'layout3',
    cdn: 'https://cdn.dotpe.in/longtail/themes/8073865/UJreDMpE.webp',
    subscription: [SUBSCRIPTION_NAMES.ELITE, SUBSCRIPTION_NAMES.PRO],
    configs: {
      updateConfigs: [
        {
          accessKey: '',
          getData(activeWidgetProps) {
            return 'layout3';
          },
        },
        {
          accessKey: ['sortAndFilter', 'desktop_configs', 'filter_options_size'],
          getData(activeWidgetProps) {
            return 'medium';
          },
        },
        {
          accessKey: ['sortAndFilter', 'filter_options_thickness'],
          getData(activeWidgetProps) {
            return 'regular';
          },
        },
        {
          accessKey: ['sortAndFilter', 'filter_options_color'],
          getData(activeWidgetProps) {
            return '#586072';
          },
        },
        {
          accessKey: ['caligraphyCollection', 'text_size_desktop'],
          getData(activeWidgetProps) {
            return 'displayLarge';
          },
        },
        {
          accessKey: ['caligraphyCategory', 'text_size_desktop'],
          getData(activeWidgetProps) {
            return 'displayLarge';
          },
        }
      ],
    },
  },
];

export const FILTER_DESIGN_LAYOUTS_MOBILE = [
  {
    name: 'layout1',
    cdn: 'https://cdn.dotpe.in/longtail/themes/8073865/H2aKenxZ.webp',
    subscription: [
      SUBSCRIPTION_NAMES.ESSENTIAL,
      SUBSCRIPTION_NAMES.ELITE,
      SUBSCRIPTION_NAMES.PRO,
    ],
    configs: {
      updateConfigs: [
        {
          accessKey: '',
          getData(activeWidgetProps) {
            return 'layout1';
          },
        },
        {
          accessKey: ['sortAndFilter', 'mobile_configs', 'filter_options_size'],
          getData(activeWidgetProps) {
            return 'medium';
          },
        },
        {
          accessKey: ['caligraphyCollection', 'text_size_mobile'],
          getData(activeWidgetProps) {
            return 'large';
          },
        },
        {
          accessKey: ['caligraphyCategory', 'text_size_mobile'],
          getData(activeWidgetProps) {
            return 'large';
          },
        }
      ],
    },
  },
  {
    name: 'layout2',
    cdn: 'https://cdn.dotpe.in/longtail/themes/8073865/ZEEcGP0X.webp',
    subscription: [
      SUBSCRIPTION_NAMES.ESSENTIAL,
      SUBSCRIPTION_NAMES.ELITE,
      SUBSCRIPTION_NAMES.PRO,
    ],
    configs: {
      updateConfigs: [
        {
          accessKey: '',
          getData(activeWidgetProps) {
            return 'layout2';
          },
        },
        {
          accessKey: ['sortAndFilter', 'mobile_configs', 'filter_options_size'],
          getData(activeWidgetProps) {
            return 'regular';
          },
        },
        {
          accessKey: ['caligraphyCollection', 'text_size_mobile'],
          getData(activeWidgetProps) {
            return 'displayMedium';
          },
        },
        {
          accessKey: ['caligraphyCategory', 'text_size_mobile'],
          getData(activeWidgetProps) {
            return 'displayMedium';
          },
        }
      ],
    },
  },
];

export const COLOR_SELECTION_LAYOUTS = [
  {
    name: 'layout1',
    cdn: 'https://cdn.dotpe.in/longtail/themes/8073865/BUznqj6P.webp',
    subscription: [
      SUBSCRIPTION_NAMES.ESSENTIAL,
      SUBSCRIPTION_NAMES.ELITE,
      SUBSCRIPTION_NAMES.PRO,
    ],
    configs: {
      updateConfigs: [
        {
          forType: '',
          getData(activeWidgetProps) {
            return 'layout1';
          },
        },
      ],
    },
  },
  {
    name: 'layout2',
    cdn: 'https://cdn.dotpe.in/longtail/themes/8073865/ExNvVyUp.webp',
    subscription: [
      SUBSCRIPTION_NAMES.ESSENTIAL,
      SUBSCRIPTION_NAMES.ELITE,
      SUBSCRIPTION_NAMES.PRO,
    ],
    configs: {
      updateConfigs: [
        {
          forType: '',
          getData(activeWidgetProps) {
            return 'layout2';
          },
        },
      ],
    },
  },
  {
    name: 'layout3',
    cdn: 'https://cdn.dotpe.in/longtail/themes/8073865/hYzCCDYj.webp',
    subscription: [
      SUBSCRIPTION_NAMES.ESSENTIAL,
      SUBSCRIPTION_NAMES.ELITE,
      SUBSCRIPTION_NAMES.PRO,
    ],
    configs: {
      updateConfigs: [
        {
          forType: '',
          getData(activeWidgetProps) {
            return 'layout3';
          },
        },
      ],
    },
  },
];

export const SIZE_SELECTION_LAYOUTS = [
  {
    name: 'layout1',
    cdn: 'https://cdn.dotpe.in/longtail/themes/8073865/u4Qs2jIL.webp',
    subscription: [
      SUBSCRIPTION_NAMES.ESSENTIAL,
      SUBSCRIPTION_NAMES.ELITE,
      SUBSCRIPTION_NAMES.PRO,
    ],
    configs: {
      updateConfigs: [
        {
          forType: '',
          getData(activeWidgetProps) {
            return 'layout1';
          },
        },
      ],
    },
  },
  {
    name: 'layout2',
    cdn: 'https://cdn.dotpe.in/longtail/themes/8073865/MC6AKnIT.webp',
    subscription: [
      SUBSCRIPTION_NAMES.ESSENTIAL,
      SUBSCRIPTION_NAMES.ELITE,
      SUBSCRIPTION_NAMES.PRO,
    ],
    configs: {
      updateConfigs: [
        {
          forType: '',
          getData(activeWidgetProps) {
            return 'layout2';
          },
        },
      ],
    },
  },
];

export const MATERIAL_SELECTION_LAYOUTS = [
  {
    name: 'layout1',
    cdn: 'https://cdn.dotpe.in/longtail/themes/8073865/9D7eRU1H.webp',
    subscription: [
      SUBSCRIPTION_NAMES.ESSENTIAL,
      SUBSCRIPTION_NAMES.ELITE,
      SUBSCRIPTION_NAMES.PRO,
    ],
    configs: {
      updateConfigs: [
        {
          forType: '',
          getData(activeWidgetProps) {
            return 'layout1';
          },
        },
      ],
    },
  },
  {
    name: 'layout2',
    cdn: 'https://cdn.dotpe.in/longtail/themes/8073865/t5iYOPkW.webp',
    subscription: [
      SUBSCRIPTION_NAMES.ESSENTIAL,
      SUBSCRIPTION_NAMES.ELITE,
      SUBSCRIPTION_NAMES.PRO,
    ],
    configs: {
      updateConfigs: [
        {
          forType: '',
          getData(activeWidgetProps) {
            return 'layout2';
          },
        },
      ],
    },
  },
];
